import React from 'react';
import {
  getRehydratableName,
  Typography,
  Sizes,
  Rank,
  Link,
  Heading,
  getClassNameFactory,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { EMAIL_US } from './utils/constants';
import { IEmailUsProps } from './types';
import EmailUsIcon from './EmailUsIcon';
import './index.css';

export const EmailUs: React.FC<IEmailUsProps> = (props) => {
  const {
    title,
    description,
    emailAddress,
    emailText,
    isBorderVisible,
  } = props;
  const hrefTextForEmailUsLink = EMAIL_US.MAIL_TO.replace(
    '<emailid>',
    emailAddress
  );
  const getClassName = getClassNameFactory(EmailUs.displayName);
  return (
    <div
      data-rehydratable={getRehydratableName(EmailUs.displayName)}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <div
        className={getClassName({
          descendantName: 'container',
          modifiers: isBorderVisible && 'border',
        })}
      >
        <div
          className={getClassName({
            descendantName: 'textContainer',
            modifiers: isBorderVisible && 'visible',
          })}
        >
          <Heading
            type={types.XtraSmall}
            boldType={boldTypes.black}
            rank={Rank.Second}
            className={getClassName({ descendantName: 'heading' })}
          >
            {title}
          </Heading>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            className={getClassName({ descendantName: 'description' })}
          >
            {description}
          </Typography>
        </div>
        <div className={getClassName({ descendantName: 'icon' })}>
          <Link
            iconLeft={<EmailUsIcon />}
            href={hrefTextForEmailUsLink}
            newWindow
          >
            <span
              className={getClassName({ descendantName: 'linkText' })}
              data-testid="emailLink"
            >
              {emailText}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

EmailUs.displayName = 'EmailUs';
